// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mO4Sz5usGTybtCEaRqaI+*{margin-top:30px}", "",{"version":3,"sources":["webpack://./src/uikit/components/UikHeadlineDesc/headline-desc.module.scss"],"names":[],"mappings":"AACE,wBACE,eAAA","sourcesContent":[".wrapper {\n  & + * {\n    margin-top: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "mO4Sz5usGTybtCEaRqaI"
};
export default ___CSS_LOADER_EXPORT___;
